// Application constants

// Environment based API URL
const isDevelopment = process.env.NODE_ENV === 'development';
export const API_BASE_URL = isDevelopment 
  ? "https://viora.click" 
  : "https://viora.click";

// Other constants
export const APP_NAME = "Viora";
export const DEFAULT_TIMEOUT = 10000;

// API Endpoints
export const ENDPOINTS = {
  AUTH: '/dev/website/auth',
  CHARACTERS: '/character/all',
  CHARACTER_UPDATE: '/character/update',
  CHARACTER_UPDATE_BULK: '/character/updateBulk',
  CHARACTER_DELETE: '/dev/website/character',
  CHARACTER_DELETE_VIDEO: '/dev/website/character/delete-video',
  CHARACTER_DELETE_IMAGE: '/dev/website/character/delete-image',
  CHARACTER_UPDATE_GIFT_IMAGES: '/dev/website/character/update-gift-images',
  CHARACTER_DELETE_GIFT_IMAGE: '/dev/website/character/delete-gift-image',
  CHARACTER_UPLOAD_GREETING_VIDEO: '/dev/website/character/upload-greeting-video',
  CHARACTER_DELETE_GREETING_VIDEO: '/dev/website/character/delete-greeting-video',
  GIFTS: '/gift',
  GIFT_CREATE: '/gift/create',
  CHARACTER_GIFT_CREATE: '/gift/create/characterGift',
  CHARACTER_GIFTS: '/gift/characterGift/all',
}; 